import React, { useContext, useImperativeHandle, useCallback } from 'react'
import GenericButton, { GenericButtonProps } from '../components/GenericButton'
import { WorkflowContext } from './WorkflowContext'
import styled from 'styled-components'

export interface WorkflowButtonProps extends GenericButtonProps {
  onWorkflowComplete?: (data: { [key: string]: any }) => any
}

const WorkflowButton: React.ForwardRefRenderFunction<
  any,
  WorkflowButtonProps
> = ({ onClick, onWorkflowComplete, ...props }, ref) => {
  const { state, dispatch } = useContext(WorkflowContext)
  const clickHandler = useCallback(
    (e?: any) => {
      if (
        state.currentStep &&
        state.steps.indexOf(state.currentStep) + 1 === state.steps.length &&
        !state.currentStep?.getNextStepId
      ) {
        onWorkflowComplete?.(state.data)
        dispatch({
          type: 'clearSavedState',
          value: {
            complete: true,
          },
        })
      } else {
        dispatch({
          type: 'nextStep',
          value: {},
        })
      }

      onClick?.(e)
    },
    [
      onClick,
      dispatch,
      onWorkflowComplete,
      state.currentStep,
      state.data,
      state.steps,
    ]
  )

  useImperativeHandle(ref, () => ({
    click() {
      clickHandler()
    },
  }))

  return <GenericButton onClick={clickHandler} {...props} />
}

export default styled(React.memo(React.forwardRef(WorkflowButton)))`
  margin-bottom: 40px;
`
